import { render } from "./ForgotPasswordIndex.vue?vue&type=template&id=64601e08"
import script from "./ForgotPasswordIndex.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__